import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

/**
 * Polymorphic component for rendering paragraphs.
 */ const Paragraph = ({ as: Component = 'p', small, strong, strikeThrough, underline, inline, className, ...rest })=>{
    return jsx(Component, {
        className: classNames('p', {
            small,
            strong,
            underline,
            'strike-through': strikeThrough,
            'm-0': inline
        }, className),
        ...rest
    });
};

export { Paragraph };
